/** @format */
import {Tab, Tabs} from '@sttark/design-system';
import {AddressesTab} from './addresses_tab';
import React, {useState} from 'react';

// styles
import './container.scss';

export default () => {
    const [activeTab, setActiveTab] = useState('shipping');

    const onTabChangeTab = tab => {
        setActiveTab(tab);
    };
    return (
        <section className="user-addresses-51qz mt-4">
            <Tabs activeTab={activeTab} onChange={onTabChangeTab} className={'tabs mb-0'}>
                <Tab title={`Shipping Addresses`} name="shipping">
                    <section className="orders-view-order-05jr__card-section">
                        <AddressesTab isShippingAddress />
                    </section>
                </Tab>
                <Tab title={`Billing Addresses`} name="billing">
                    <AddressesTab />
                </Tab>
            </Tabs>
        </section>
    );
};
